// flutter通道

import { ITrackProductInfoAppParams } from "@/shared";

// 全局对象声明，防止 TS 报错
declare const YooFindsGoBackHome:
  | { postMessage: (msg: string) => void }
  | undefined;
declare const YooFindsOpenProductDetail:
  | { postMessage: (msg: string) => void }
  | undefined;
declare const YooFindsJumpEveryWhereYouWant:
  | { postMessage: (msg: string) => void }
  | undefined;
declare const YooFindsOpenWithExternalBrowser:
  | { postMessage: (msg: string) => void }
  | undefined;
declare const YooFindsOpenLoginPage:
  | { postMessage: (msg: string) => void }
  | undefined;
declare const YooFindsDiscord:
  | { postMessage: (msg: string) => void }
  | undefined;
declare const YooFindsOpenHighComm:
  | { postMessage: (msg: string) => void }
  | undefined;
declare const YooFindsOpenWaitingFulFill:
  | { postMessage: (msg: string) => void }
  | undefined;
declare const YooFindsOpenWallet:
  | { postMessage: (msg: string) => void }
  | undefined;
declare const YooFindsOpenProfile:
  | { postMessage: (msg: string) => void }
  | undefined;
declare const YooFindsShare: { postMessage: (msg: string) => void } | undefined;
declare const YooFindsAccountSwiper:
  | { postMessage: (msg: string) => void }
  | undefined;
declare const YooFindsOpenHigherCommission:
  | { postMessage: (msg: string) => void }
  | undefined;
declare const YooFindsLoginToOtherPage:
  | { postMessage: (msg: string) => void }
  | undefined;
declare const YooFindsOpenSampleAuthorize:
  | { postMessage: (msg: string) => void }
  | undefined;
declare const YooFindsSetH5Title:
  | { postMessage: (msg: string) => void }
  | undefined;
declare const YooFindsOpenSampleDetail:
  | { postMessage: (msg: string) => void }
  | undefined;
declare const YooFindsGoBack:
  | { postMessage: (msg: string) => void }
  | undefined;
declare const YooFindsOpenMemberShip:
  | { postMessage: (msg: string) => void }
  | undefined;
declare const YooFindsOpenLink:
  | { postMessage: (msg: string) => void }
  | undefined;
declare const YooFindsClose: { postMessage: (msg: string) => void } | undefined;
declare const YooFindsOpenTrackProduct:
  | { postMessage: (msg: string) => void }
  | undefined;

declare const YooFindsCheckSampleAddress:
  | { postMessage: (msg: string) => void }
  | undefined;

export class YooFindsChannel {
  static callOpenProductDetail(
    hashId: string,
    sourceParams?: ITrackProductInfoAppParams
  ) {
    if (sourceParams && typeof YooFindsOpenTrackProduct !== "undefined") {
      const params = {
        hashId: hashId,
        sourceParams: sourceParams,
      };
      YooFindsOpenTrackProduct.postMessage(JSON.stringify(params));
      return;
    }
    if (typeof YooFindsOpenProductDetail !== "undefined") {
      YooFindsOpenProductDetail.postMessage(hashId);
    }
  }

  static callJumpAppUrl(routeQuery: any) {
    if (typeof YooFindsJumpEveryWhereYouWant !== "undefined") {
      YooFindsJumpEveryWhereYouWant.postMessage(JSON.stringify(routeQuery));
    }
  }

  static callOpenWithExternalBrowser(url: string) {
    if (typeof YooFindsOpenWithExternalBrowser !== "undefined") {
      YooFindsOpenWithExternalBrowser.postMessage(url);
    }
  }

  static callGoBackHome() {
    if (typeof YooFindsGoBackHome !== "undefined") {
      YooFindsGoBackHome.postMessage("");
    }
  }

  static callOpenLoginPage() {
    if (typeof YooFindsOpenLoginPage !== "undefined") {
      YooFindsOpenLoginPage.postMessage("");
    }
  }

  static callJumpDiscord(url: string) {
    if (typeof YooFindsDiscord !== "undefined") {
      YooFindsDiscord.postMessage(url);
    }
  }

  static callOpenHighComm() {
    if (typeof YooFindsOpenHighComm !== "undefined") {
      YooFindsOpenHighComm.postMessage("");
    }
  }

  static callOpenWaitingFulFill() {
    if (typeof YooFindsOpenWaitingFulFill !== "undefined") {
      YooFindsOpenWaitingFulFill.postMessage("");
    }
  }

  static callJumpWallet() {
    if (typeof YooFindsOpenWallet !== "undefined") {
      YooFindsOpenWallet.postMessage("");
    }
  }

  static callOpenProfile(url: string) {
    if (typeof YooFindsOpenProfile !== "undefined") {
      YooFindsOpenProfile.postMessage(url);
    }
  }

  static callYooFindsShare(share_url: string) {
    if (typeof YooFindsShare !== "undefined") {
      YooFindsShare.postMessage(share_url);
    }
  }

  static callAccountSwiper(message: string) {
    if (typeof YooFindsAccountSwiper !== "undefined") {
      YooFindsAccountSwiper.postMessage(message);
    }
  }

  static callOpenHigherCommission() {
    if (typeof YooFindsOpenHigherCommission !== "undefined") {
      YooFindsOpenHigherCommission.postMessage("");
    }
  }

  static callLoginToOtherPage(jumpUrl: string) {
    if (typeof YooFindsLoginToOtherPage !== "undefined") {
      YooFindsLoginToOtherPage.postMessage(jumpUrl);
    }
  }

  static callOpenSampleAuthorize(jumpUrl: string) {
    if (typeof YooFindsOpenSampleAuthorize !== "undefined") {
      YooFindsOpenSampleAuthorize.postMessage(jumpUrl);
    }
  }

  static callYooFindsSetH5Title(title: string) {
    if (typeof YooFindsSetH5Title !== "undefined") {
      YooFindsSetH5Title.postMessage(title);
    }
  }

  static callYooFindsOpenSampleDetail(sampleOrderId: string) {
    if (typeof YooFindsOpenSampleDetail !== "undefined") {
      YooFindsOpenSampleDetail.postMessage(sampleOrderId);
    }
  }

  static callYooFindsCallback() {
    if (typeof YooFindsGoBack !== "undefined") {
      YooFindsGoBack.postMessage("");
    }
  }

  static callYooFindsMemberShipPage() {
    if (typeof YooFindsOpenMemberShip !== "undefined") {
      YooFindsOpenMemberShip.postMessage("");
    }
  }

  static callYooFindsOpenHigherCommission() {
    if (typeof YooFindsOpenHigherCommission !== "undefined") {
      YooFindsOpenHigherCommission.postMessage("");
    }
  }

  static callYooFindsOpenWallet() {
    if (typeof YooFindsOpenWallet !== "undefined") {
      YooFindsOpenWallet.postMessage("");
    }
  }

  static callYooFindsOpenLink(param: any) {
    if (typeof YooFindsOpenLink !== "undefined") {
      YooFindsOpenLink.postMessage(JSON.stringify(param));
    }
  }

  static callYooFindsCloseWebview() {
    if (typeof YooFindsClose !== "undefined") {
      YooFindsClose.postMessage("");
    }
  }

  static callCheckSampleAddress(jumpUrl: string) {
    if (typeof YooFindsCheckSampleAddress !== "undefined") {
      YooFindsCheckSampleAddress.postMessage(jumpUrl);
    }
  }

  static callYooFindsAdTask(taskOrderId: string) {
    if (typeof YooFindsJumpEveryWhereYouWant !== "undefined") {
      YooFindsJumpEveryWhereYouWant.postMessage(
        JSON.stringify({
          router: "adTaskDetailPage",
          params: { task_order_id: taskOrderId },
        })
      );
    }
  }
}
